import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { ForgeButtonModule } from "@tylertech/forge-angular";

export interface AlertDialogData
{
    readonly title?: string;
    readonly message: string;
    readonly okLabel?: string;
}

@Component({
    selector: "alert-dialog",
    templateUrl: "./alert.tmpl.html",
    imports: [
        CdkScrollable,
        ForgeButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class AlertDialogComponent
{
    private readonly data = inject<AlertDialogData>(MAT_DIALOG_DATA);


    get title(): string { return this.data.title ?? "Error"; }
    get message(): string { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }
}
